'use client';

import { c as _c } from "react/compiler-runtime";
import type { TOC } from '@/mdx-plugins';
import { AlignLeftIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

/*import { Button } from '@/components/ui/button'*/
import { Link } from '@/components/ui/link';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { useRouter } from '@/i18n/routing';
type MobileTableOfContentsProps = {
  toc: TOC[];
};
export function MobileTableOfContents(props) {
  const $ = _c(16);
  const {
    toc
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AlignLeftIcon data-icon="inline-start" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("blog.on-this-page");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <PopoverTrigger className="fixed right-2 bottom-2 z-50 lg:hidden flex items-center gap-2 rounded-md bg-secondary px-4 py-2 text-sm font-medium hover:bg-secondary/80">{t0} {t1}</PopoverTrigger>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== router || $[6] !== toc) {
    let t4;
    if ($[8] !== router) {
      t4 = item => {
        const {
          title,
          url,
          depth
        } = item;
        return <Link key={url} href={{
          hash: url
        }} className="block py-2 pr-2.5 text-sm/tight text-muted-foreground transition-colors hover:text-foreground" style={{
          paddingLeft: (depth - 1) * 16
        }} onClick={() => {
          router.push(`#${url}`);
          setIsOpen(false);
        }}>{title}</Link>;
      };
      $[8] = router;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = toc.map(t4);
    $[5] = router;
    $[6] = toc;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <PopoverContent align="end" side="top" className="px-0 py-2">{t3}</PopoverContent>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== isOpen || $[13] !== t2 || $[14] !== t4) {
    t5 = <Popover open={isOpen} onOpenChange={setIsOpen}>{t2}{t4}</Popover>;
    $[12] = isOpen;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}